import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { PaxOverviewType } from 'src/app/crew-management-user/enums/pax-overview-type.enum';
import { Privileges } from 'src/app/core/privileges/privileges';

@Component({
  selector: 'app-pax-template',
  templateUrl: './pax-template.component.html',
  standalone: false,
})
export class PaxTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };
  paxOverviewType = PaxOverviewType;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  Privileges = Privileges;
}
